import {Component} from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {RoomProvider} from "../../providers/room/room";
import {TranslateService} from "@ngx-translate/core";
import FIGHT_MODE from "../fight/FIGHT_MODE";
import CONFIG_PAGES from "../CONFIG_PAGES";

/**
 * Generated class for the FightFormPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-fight-form',
    templateUrl: 'fight-form.html',
    providers: [RoomProvider]
})
export class FightFormPage {
    modes = FIGHT_MODE;
    model: any = {
        level: 'soroban',
        sub_level: 'SorobanBasicBoardPage',
        room_type: 'SINGLE'
    };

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public roomProvider: RoomProvider,
                public alertCtrl: AlertController,
                public translate: TranslateService,
                public loadingCtrl: LoadingController) {
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad FightFormPage');
        this.onChangeSubLevel();
    }


    save() {
        const loader = this.loadingCtrl.create({
            content: "Please wait..."
        });
        loader.present();

        this.roomProvider.save(this.model).subscribe((resp: any) => {
            this.navCtrl.pop();

            loader.dismiss();
            this.navCtrl.push(CONFIG_PAGES[this.model.board_name], {room: resp.data});
        }, err => {
            loader.dismiss();
            console.log(err);
        });
    }

    onChangeSubLevel() {
        switch (this.model.sub_level) {
            case 'SorobanBasicBoardPage':
                this.model.board_name = 'SorobanBasicFlashCardPage';
                break;
            case 'SorobanAddSubBoardPage':
                this.model.board_name = 'SorobanAddSubAddSubPage';
                break;
            case 'SorobanMultiBoardPage':
                this.model.board_name = 'SorobanMultiOnePage';
                break;
            case 'SorobanDivisionBoardPage':
                this.model.board_name = 'SorobanDivisonOnePage';
                break;
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/fight-form/fight-form.ts